import * as types from '../people_notifications/action_types';
import Liker from '../../services/liker';

export const like = (commentSlug) => {
  return async(dispatch) => {
    try {
      await Liker.likeComment(commentSlug);
    } catch(error) {
      dispatch({ type: types.PEOPLE_NOTIFICATIONS_ERROR, error });
    }
  }
}

export const unLike = (commentSlug) => {
  return async(dispatch) => {
    try {
      await Liker.unLikeComment(commentSlug);
    } catch(error) {
      dispatch({ type: types.PEOPLE_NOTIFICATIONS_ERROR, error });
    }
  }
}



// WEBPACK FOOTER //
// ./src/stores/comment_likes/actions.js